import { useState, useEffect } from "react";
import styles from "./InicioInformacionUsuario.module.css";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";

import Modal from "react-bootstrap/Modal";

import perfil from "../../src/assets/img/Inicio/PerfilDefault.png";
import { Buffer } from "buffer";
import { ConsultaWS, ConsultaWSGet } from "../Commons/ServiciosBase";
import {
  ConsultarSaldosCorrientes_Respuesta,
  ConsultarSaldosCorrientes_Parametros,
  ConsultarSaldosCorrientes_Entrada,
  builtConsultarSaldosCorrientesInput,
} from "../Commons/Services/ConsultarSaldosCorrientesRest";
import { decryptBase64ArrayByteToString } from "../Commons/EncriptText";
import Loading from "../General/Loading";
import {
  builtConsultaPagosPorEventEntrada,
  ConsultaPagosPorEvento_Entrada,
  ConsultaPagosPorEvento_Parametros,
  ConsultaPagosPorEvento_Respuesta,
} from "../Commons/Services/ConsultaPagosPorEvento";
import {
  ConsultarAvatarCuenta_Parametros,
  ConsultarAvatarCuenta_Respuesta,
} from "../Commons/Services/ConsultarAvatarCuenta";
import { determinaMoneda } from "../Utils/Monedas";

import disney_nvo from "../assets/img/Cartetelera/big/disneyplus_nvo_gde.jpeg";
import {
  builtConsultaCuentaRestInput,
  ConsultaCuenta_Respuesta,
  ConsultaCuentaRest_Entrada,
  ConsultaCuentaRest_Parametros,
  InstanceComponent,
  ServiceInstance,
} from "../Commons/Services/ConsultaCuentaRest";

export const InicioInformacionUsuario = () => {
  const [usuario, setUsuario] = useState(
    sessionStorage.getItem("flujos") !== "Sky+"
      ? sessionStorage.getItem("Nombre")
      : sessionStorage.getItem("nombre")
  );
  const [saldo, setSaldo] = useState("");
  const [paquete, setPaquete] = useState(
    sessionStorage.getItem("flujos") !== "Sky+"
      ? sessionStorage.getItem("Paquete")
      : sessionStorage.getItem("PaqueteSky+")
  );
  const [fechaLimite, setFechaLimite] = useState("");
  const [loading, isLoading] = useState(false);
  const [moneda, setMoneda] = useState(
    determinaMoneda(
      sessionStorage.getItem("pais")!,
      sessionStorage.getItem("flujos")!
    )
  );

  const [flujo, setFlujo] = useState(sessionStorage.getItem("flujos"));
  const myCuenta =
    flujo === "Sky+"
      ? sessionStorage.getItem("cuenta")!
      : sessionStorage.getItem("cuenta")!;

  const obtenerSaldo = (
    p_ConsultarSaldosCorrientesRespuesta: ConsultarSaldosCorrientes_Respuesta
  ) => {
    if (
      p_ConsultarSaldosCorrientesRespuesta.SaldosCorrientesEBO
        .FechaPagoOportuno != null &&
      p_ConsultarSaldosCorrientesRespuesta.SaldosCorrientesEBO
        .FechaPagoOportuno != ""
    ) {
      return p_ConsultarSaldosCorrientesRespuesta.SaldosCorrientesEBO
        .SaldoTotalPagoOportuno;
    } else {
      return p_ConsultarSaldosCorrientesRespuesta.SaldosCorrientesEBO
        .SaldoTotal;
    }
  };

    const obtieneSaldoFecha = async () => {
        // function obtieneSaldoFecha() {
        isLoading(true);
        //----------------------------------------------------------------------------------------------------------------------------
        const ConsultarSaldosCorrientesDO: ConsultarSaldosCorrientes_Entrada =
            builtConsultarSaldosCorrientesInput(myCuenta);
        let par = ConsultarSaldosCorrientes_Parametros(ConsultarSaldosCorrientesDO);
        let ConsultarSaldosCorrientesRespuesta: ConsultarSaldosCorrientes_Respuesta = await ConsultaWS(par);

        if (
            ConsultarSaldosCorrientesRespuesta.EBMHeaderResponse &&
            ConsultarSaldosCorrientesRespuesta.EBMHeaderResponse.ErrorNegocio.Estado == "ok" &&
            ConsultarSaldosCorrientesRespuesta.EBMHeaderResponse.ErrorTecnico.code === "ok"
        ) {
            if (ConsultarSaldosCorrientesRespuesta.SaldosCorrientesEBO.FechaPagoOportuno !== null) {
                let saldoFormato: number = Number.parseFloat(
                    ConsultarSaldosCorrientesRespuesta.SaldosCorrientesEBO.SaldoTotalPagoOportuno,
                ); //parseInt( );

        setSaldo(saldoFormato.toString());

                sessionStorage.setItem(
                    "saldo",
                    ConsultarSaldosCorrientesRespuesta.SaldosCorrientesEBO.SaldoTotalPagoOportuno,
                );
                //let saldo =                ConsultarSaldosCorrientesRespuesta.SaldosPorFacturarEBO.SaldoTotalMasCargosPorFacturar;
                let cadena = ConsultarSaldosCorrientesRespuesta.SaldosCorrientesEBO.FechaPagoOportuno.substring(0, 10);
                const ar = cadena.split("-");
                setFechaLimite(ar[2] + "/" + ar[1] + "/" + ar[0]);
                sessionStorage.setItem("fechaFin", ar[2] + "-" + ar[1] + "-" + ar[0]);
            } else {
                let saldoFormato: number = Number.parseFloat(
                    ConsultarSaldosCorrientesRespuesta.SaldosCorrientesEBO.SaldoTotal,
                ); //parseInt();

        setSaldo(saldoFormato.toString());

                sessionStorage.setItem("saldo", ConsultarSaldosCorrientesRespuesta.SaldosCorrientesEBO.SaldoTotal);
                //let saldo =                  ConsultarSaldosCorrientesRespuesta.SaldosPorFacturarEBO.SaldoTotalMasCargosPorFacturar;
                let cadena = ConsultarSaldosCorrientesRespuesta.SaldosPorFacturarEBO.FechaProximoCorte.substring(0, 10);
                const ar = cadena.split("-");
                setFechaLimite(ar[2] + "/" + ar[1] + "/" + ar[0]);
                sessionStorage.setItem("fechaFin", ar[2] + "-" + ar[1] + "-" + ar[0]);
            }

      isLoading(false);
    } else {
      console.error(ConsultarSaldosCorrientesRespuesta.EBMHeaderResponse);
      isLoading(false);
    }

    //----------------------------------------------------------------------------------------------------------------------------
  };

  const [accountAvatar, setAccountAvatar] = useState("");

  async function getAvatar() {
    let ConsultarAvatarCuentaParametros = ConsultarAvatarCuenta_Parametros(
      null,
      `${myCuenta}`
    );

    let ConsultarAvatarCuentaRespuesta: ConsultarAvatarCuenta_Respuesta =
      await ConsultaWSGet(ConsultarAvatarCuentaParametros);
    setAccountAvatar(
      ConsultarAvatarCuentaRespuesta.content[0]?.catalogoAvatar?.avatarBase64
        ? ConsultarAvatarCuentaRespuesta.content[0]?.catalogoAvatar
            ?.avatarBase64
        : perfil
    );
  }

  const [ConsultaCuentaRespuesta, setConsultaCuentaRespuesta] =
    useState<ConsultaCuenta_Respuesta | null>(null);

  const doConsultaCuentaRest = async () => {
    try {
      //----------------------------------------------------------------------------------------------------------------------------
      const ConsultaCuentaRestEntrada: ConsultaCuentaRest_Entrada =
        builtConsultaCuentaRestInput(`${flujo === "Sky+"
          ? sessionStorage.getItem("cuenta")!
          : sessionStorage.getItem("cuenta")! ?? ""}`);
      let ConsultaCuentaRestParametros = ConsultaCuentaRest_Parametros(
        ConsultaCuentaRestEntrada
      );

      let ConsultaCuentaRespuesta: ConsultaCuenta_Respuesta = await ConsultaWS(
        ConsultaCuentaRestParametros
      );

      if (
        ConsultaCuentaRespuesta.EBMHeaderResponse &&
        ConsultaCuentaRespuesta.EBMHeaderResponse.ErrorNegocio.Estado ===
          "ok" &&
        ConsultaCuentaRespuesta.EBMHeaderResponse.ErrorTecnico.code === "ok"
      ) {
        setConsultaCuentaRespuesta(ConsultaCuentaRespuesta);
        return ConsultaCuentaRespuesta;
      } else {
        console.error("Error al ejecutar el servicio");
        console.error(ConsultaCuentaRespuesta);
        return null;
      }
      //----------------------------------------------------------------------------------------------------------------------------
    } catch (error) {
      console.error("Error al ejecutar el servicio");
      console.error(error);
      return null;
      // Expected output: ReferenceError: nonExistentFunction is not defined
      // (Note: the exact output may be browser-dependent)
    }
  };

  useEffect(() => {
    if (flujo === "Sky+") {
      obtieneSaldoFecha();
      getAvatar();
    } else {
      obtieneSaldoFecha();

      getAvatar();
    }

    doConsultaCuentaRest().then((response) => {
      // ok
    });
  }, []);

  const getServiceFamilyFlag = (
    p_ConsultaCuentaRespuesta: ConsultaCuenta_Respuesta | null,
    p_nombreservicio: string
  ) => {
    let retorno = false;

    let InstanceComponentArray: InstanceComponent[] =
      p_ConsultaCuentaRespuesta?.ConsultaCuenta_Salida?.ListOfAccount?.Account[0]?.ListOfServiceInstance?.ServiceInstance.find(
        (x: ServiceInstance) =>
          x.ServiceProductType === "VIDEO" &&
          x.SlaveHierarchy === "Master" &&
          x.StatusCode === "Activo"
      )?.ListOfInstanceComponent?.InstanceComponent!;

    if (
      InstanceComponentArray === undefined ||
      InstanceComponentArray === null
    ) {
      InstanceComponentArray = [];
    }

    InstanceComponentArray.map(
      (instanceComponent: InstanceComponent, index: number) => {
        let nombreProducto = instanceComponent.Product;

        if (
          nombreProducto.toLowerCase().includes(p_nombreservicio.toLowerCase())
        ) {
          retorno = true;
        }
      }
    );

    return retorno;
  };

  const [showModalDisneyDisneyPlus, setShowModalDisneyDisneyPlus] = useState(
    getServiceFamilyFlag(ConsultaCuentaRespuesta, "Disney+") &&
      localStorage.getItem("noMostrarModalDisneyDisneyPlus") === null
  );
  const [isDisabledModalDisneyDisneyPlus, setIsDisabledModalDisneyDisneyPlus] =
    useState(false);

  const handleCloseModalDisneyDisneyPlus = () =>
    setShowModalDisneyDisneyPlus(false);
  const handleShowModalDisneyDisneyPlus = () =>
    setShowModalDisneyDisneyPlus(true);

  const handleDontShowAgainModalDisneyDisneyPlus = () => {
    // save and persist to storage the setting to no longer show the modal
    setIsDisabledModalDisneyDisneyPlus(true);
    localStorage.setItem("noMostrarModalDisneyDisneyPlus", "true");

    // close the modal
    handleCloseModalDisneyDisneyPlus();
  };

  const [showModalDisneyStarPlus, setShowModalDisneyStarPlus] = useState(
    getServiceFamilyFlag(ConsultaCuentaRespuesta, "Star+") &&
      localStorage.getItem("noMostrarModalDisneyStarPlus") === null
  );
  const [isDisabledModalDisneyStarPlus, setIsDisabledModalDisneyStarPlus] =
    useState(false);

  const handleCloseModalDisneyStarPlus = () =>
    setShowModalDisneyStarPlus(false);
  const handleShowModalDisneyStarPlus = () => setShowModalDisneyStarPlus(true);

  const handleDontShowAgainModalDisneyStarPlus = () => {
    // save and persist to storage the setting to no longer show the modal
    setIsDisabledModalDisneyStarPlus(true);
    localStorage.setItem("noMostrarModalDisneyStarPlus", "true");

    // close the modal
    handleCloseModalDisneyStarPlus();
  };

  const [showModalDisneyComboPlus, setShowModalDisneyComboPlus] = useState(
    getServiceFamilyFlag(ConsultaCuentaRespuesta, "Combo+") &&
      localStorage.getItem("noMostrarModalDisneyComboPlus") === null
  );
  const [isDisabledModalDisneyComboPlus, setIsDisabledModalDisneyComboPlus] =
    useState(false);

  const handleCloseModalDisneyComboPlus = () =>
    setShowModalDisneyComboPlus(false);
  const handleShowModalDisneyComboPlus = () =>
    setShowModalDisneyComboPlus(true);

  const handleDontShowAgainModalDisneyComboPlus = () => {
    // save and persist to storage the setting to no longer show the modal
    setIsDisabledModalDisneyComboPlus(true);
    localStorage.setItem("noMostrarModalDisneyComboPlus", "true");

    // close the modal
    handleCloseModalDisneyComboPlus();
  };

  useEffect(() => {
    if (ConsultaCuentaRespuesta !== null) {
      setShowModalDisneyDisneyPlus(
        getServiceFamilyFlag(ConsultaCuentaRespuesta, "Disney+") &&
          localStorage.getItem("noMostrarModalDisneyDisneyPlus") === null
      );

      setShowModalDisneyStarPlus(
        getServiceFamilyFlag(ConsultaCuentaRespuesta, "Star+") &&
          localStorage.getItem("noMostrarModalDisneyStarPlus") === null
      );

      setShowModalDisneyComboPlus(
        getServiceFamilyFlag(ConsultaCuentaRespuesta, "Combo+") &&
          localStorage.getItem("noMostrarModalDisneyComboPlus") === null
      );
    }
  }, [ConsultaCuentaRespuesta]);

  return (
    <>
      <Loading isLoading={loading} />

      <Container className={styles["containerPrueba"]} fluid>
        <Row>
          <Col lg={2} xl={2} xxl={2} className={styles["colAvatar"]}>
            <img src={accountAvatar} className={styles.imagen} />
          </Col>

          <Col lg={5} xl={5} xxl={5} className={styles["colInfo"]}>
            <Row>
              <Col className={styles["colUsuario"]}>
                <div>
                  <span className={styles["textoUsuario"]}>
                    ¡Hola de nuevo,{" "}
                    <b>
                      {usuario
                        ? usuario.charAt(0) +
                          usuario.substring(1, usuario.length).toLowerCase()
                        : ""}
                      !
                    </b>
                  </span>
                </div>
                <div className={styles["divSaldo"]}>
                  <span className={styles["textoSaldo"]}>
                    {parseFloat(saldo) < 0 ? (
                      <b>Tu saldo es:</b>
                    ) : (
                      <b>Tu saldo es:</b>
                    )}

                    {parseFloat(saldo) < 0 ? (
                      <span>
                        {" "}
                        -${parseFloat(saldo) * -1} {moneda}
                      </span>
                    ) : (
                      <span>
                        {" "}
                        ${saldo} {moneda}
                      </span>
                    )}
                  </span>
                </div>
                <div className={styles["divFecha"]}>
                  <span className={styles["textoFecha"]}>
                    <b>
                      {sessionStorage.getItem("tipoCliente") === "POS"
                        ? "Fecha límite de pago"
                        : "Fecha límite de recarga"}
                    </b>
                    : <span className={styles["fecha"]}>{fechaLimite}</span>
                  </span>
                </div>
              </Col>
            </Row>
          </Col>

          <Col lg={5} xl={5} xxl={5} className={styles["colCard"]}>
            <Card className={styles["card2"]}>
              <Card.Body className={styles["cardBody"]}>
                <div className={styles["divTextoCard1"]}>
                  <span className={styles["textoCard"]}>No de cuenta: </span>
                  <span className={styles["textoCardAzul"]}>
                    <b>{myCuenta}</b>
                  </span>
                </div>
                <div className={styles["divTextoCard2"]}>
                  <span className={styles["textoCard"]}>Plan: </span>
                  <span className={styles["textoCardAzul"]}>
                    <b>{paquete}</b>
                  </span>
                </div>
                <div>
                  <Button className={styles["botonCard"]} href="/realizapagos">
                    {sessionStorage.getItem("tipoCliente") === "POS"
                      ? "Realiza tu pago"
                      : "Realiza tu recarga"}
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      <Modal
                show={showModalDisneyDisneyPlus}
                onHide={handleCloseModalDisneyDisneyPlus}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header className="border-0" closeButton />
                <Modal.Body>
                    <div className={styles["modalContent"]}>
                        <div style={{ maxWidth: "340px" }} className={styles["modalItem"]}>
                            <span className={styles["modalSpectrum"]}>
                                Hay un nuevo Disney+ donde todo se encuentra
                            </span>
                        </div>
                        <div style={{ maxWidth: "36rem" }} className={styles["modalImage"]}>
                            <img src={disney_nvo} className={styles["modalImage"]} alt="" />
                        </div>
                        <div style={{ maxWidth: "460px" }} className={styles["modalItem"]}>
                            <span className={styles["modalText"]}>
                                A partir del 26 de junio de 2024, los deportes de ESPN, las series y películas de Star+,
                                estarán en Disney+
                            </span>
                            <br />
                            <span className={styles["modalText"]}>
                                Ingresa con tu mismo usuario y contraseña que utilizas actualmente en Disney+, actualiza
                                los datos de tu cuenta y empieza a disfrutar
                            </span>
                        </div>
                        <div style={{ maxWidth: "340px" }} className={styles["modalButtons"]} id="modal-buttons">
                            <div className={styles["divButtonLayout"]}>
                                <Button
                                    className={styles["primaryButton"]}
                                    onClick={handleCloseModalDisneyDisneyPlus}
                                    disabled={isDisabledModalDisneyDisneyPlus}
                                >
                                    Aceptar
                                </Button>
                            </div>
                            <div className={styles["divButtonLayout"]}>
                                <Button
                                    className={styles["linkButton"]}
                                    onClick={handleDontShowAgainModalDisneyDisneyPlus}
                                >
                                    <b>No volver a mostrar</b>
                                </Button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal
                show={showModalDisneyStarPlus}
                onHide={handleCloseModalDisneyStarPlus}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header className="border-0" closeButton />
                <Modal.Body>
                    <div className={styles["modalContent"]}>
                        <div style={{ maxWidth: "340px" }} className={styles["modalItem"]}>
                            <span className={styles["modalSpectrum"]}>Tenemos información para ti</span>
                        </div>
                        <div style={{ maxWidth: "36rem" }} className={styles["modalImage"]}>
                            <img src={disney_nvo} className={styles["modalImage"]} alt="" />
                        </div>
                        <div style={{ maxWidth: "460px" }} className={styles["modalItem"]}>
                            <span className={styles["modalText"]}>
                                Te comunicamos que a partir de 01 de agosto el nuevo precio de tu plan Disney+ será de
                                $219 y se verá reflejado en tu siguiente estado de cuenta
                            </span>
                        </div>
                        <div style={{ maxWidth: "340px" }} className={styles["modalButtons"]} id="modal-buttons">
                            <div className={styles["divButtonLayout"]}>
                                <Button
                                    className={styles["primaryButton"]}
                                    onClick={handleCloseModalDisneyStarPlus}
                                    disabled={isDisabledModalDisneyStarPlus}
                                >
                                    Aceptar
                                </Button>
                            </div>
                            <div className={styles["divButtonLayout"]}>
                                <Button
                                    className={styles["linkButton"]}
                                    onClick={handleDontShowAgainModalDisneyStarPlus}
                                >
                                    <b>No volver a mostrar</b>
                                </Button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal
                show={showModalDisneyComboPlus}
                onHide={handleCloseModalDisneyComboPlus}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header className="border-0" closeButton />
                <Modal.Body>
                    <div className={styles["modalContent"]}>
                        <div style={{ maxWidth: "340px" }} className={styles["modalItem"]}>
                            <span className={styles["modalSpectrum"]}>
                                Hay un nuevo Disney+ donde todo se encuentra
                            </span>
                        </div>
                        <div style={{ maxWidth: "36rem" }} className={styles["modalImage"]}>
                            <img src={disney_nvo} className={styles["modalImage"]} alt="" />
                        </div>
                        <div style={{ maxWidth: "460px" }} className={styles["modalItem"]}>
                            <span className={styles["modalText"]}>
                                A partir del 26 de junio de 2024 tendrás Disney+ Premium pagando $299 al mes. Todas tus
                                series, películas favoritas de Star+ y el deporte de ESPN, estarán disponibles en
                                Disney+.
                            </span>
                            <br />
                            <span className={styles["modalText"]}>
                                Ingresa con el mismo usuario y contraseña que utilizas actualmente en Disney+.
                            </span>
                            <br />
                            <span className={styles["modalText"]}>
                                Si deseas cancelar tu suscripción llama a Servicio a Clientes al 55 5169 0000.
                            </span>
                        </div>
                        <div style={{ maxWidth: "340px" }} className={styles["modalButtons"]} id="modal-buttons">
                            <div className={styles["divButtonLayout"]}>
                                <Button
                                    className={styles["primaryButton"]}
                                    onClick={handleCloseModalDisneyComboPlus}
                                    disabled={isDisabledModalDisneyComboPlus}
                                >
                                    Aceptar
                                </Button>
                            </div>
                            <div className={styles["divButtonLayout"]}>
                                <Button
                                    className={styles["linkButton"]}
                                    onClick={handleDontShowAgainModalDisneyComboPlus}
                                >
                                    <b>No volver a mostrar</b>
                                </Button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );

};

function toBase64(arg0: string) {
throw new Error("Function not implemented.");
}
